import { useQuery, gql } from '@apollo/client';
import { useQueryPromise } from '@starrez/starryutils';

export const entryQuery = gql`
    query Entry($entryID: ID!) {
        entry(entryID: $entryID) {
            entryID
            phoneNumber
            lastModifiedInfo
            activeBooking {
                checkInDate
                checkOutDate
            }
            iD1 {
                label
                value
            }
            entryDetail {
                medical
                incidentHold
                incidentHoldComments
                comments
            }
        }
        allEntryNotes(filter: [{ entryID: { eq: $entryID } }, { directoryFlag: { eq: true } }], skip: 0, limit: 1, sort: { field: ID, order: ASC }) {
            nodes {
                notes
            }
        }
    }
`;

export interface IEntryVariables {
    entryID: string;
}

export interface IEntryQueryResults {
    entry: {
        entryID: string;
        phoneNumber: string;
        lastModifiedInfo: string;
        activeBooking: {
            checkInDate: string;
            checkOutDate: string;
        };
        iD1: {
            label: string;
            value: string;
        };
        entryDetail: {
            medical: string;
            incidentHold: boolean;
            incidentHoldComments: string;
            comments: string;
        };
    };
    allEntryNotes: {
        nodes: {
            notes: string;
        }[];
    };
}

export const useEntryQuery = (variables: IEntryVariables) => useQuery<IEntryQueryResults, IEntryVariables>(entryQuery, { variables });

export const useLazyEntryQuery = () => useQueryPromise<IEntryQueryResults, IEntryVariables>(entryQuery);
